import React, { ReactElement } from 'react';
import { IBaseProps } from 'lib/data/interfaces';
import { CSSTransition } from 'react-transition-group';
import './TransitionRoute.less';

interface ITransitionRoute extends IBaseProps {
    on: string | boolean;
    case: any;
    children: ReactElement
}

export const TransitionRoute = (props: ITransitionRoute) =>
    <div className="transition-route">
        <CSSTransition
            in={props.on == props.case}
            timeout={{
                enter: 500,
                exit: 300,
            }}
            classNames="slide-transition"
            unmountOnExit
        >
            {props.children}
        </CSSTransition>
    </div>